import Setting from '../Setting'
import AdminHomePage from '../admin-homepage'
import Dashboard from '../dashboard'
import GuestList from '../guest'
import GuestDetail from '../guest/detail'
import HomePage from '../homepage'
import { ROUTE } from './config'
const route = [
  {
    path: ROUTE.DASHBOARD.PATH,
    component: Dashboard,
  },
  {
    path: '/',
    component: HomePage,
  },
  {
    path: '/home',
    component: AdminHomePage,
  },
  {
    name: ROUTE.GUEST.LIST.TITLE,
    path: ROUTE.GUEST.LIST.PATH,
    component: GuestList,
    isInSidebar: true,
    subMenu: [
      {
        name: ROUTE.GUEST.DETAIL.TITLE,
        path: ROUTE.GUEST.DETAIL.PATH,
        component: GuestDetail,
        isInSidebar: false,
      },
    ],
  },
  {
    name: ROUTE.SETTING.TITLE,
    path: ROUTE.SETTING.PATH,
    component: Setting,
    isInSidebar: true,
  },
]

export default route
